import styled from 'styled-components'
import media from 'styled-media-query'

export const ContainerCardWithImg = styled.div`
  max-width: 500px;
  max-height: 200px;
  display: flex;
  gap: 24px;
  box-sizing: border-box;

  ${media.lessThan('large')`
      flex-direction: column;
      max-height: none;
      max-width: 100%;
   `}
`

export const ContentImg = styled.div`
  height: 200px;
  width: 200px;

  ${media.lessThan('large')`
      width: 100%;
      height: 212px;
   `}
`

export const ContentText = styled.div`
  width: 100%;
  height: 200px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 5px;
  box-sizing: border-box;

  ${media.lessThan('medium')`
     height: auto;
   `}
`

export const TextTitle = styled.h4`
  color: var(--brand-dasa);
  font-size: 20px;
  font-weight: 700;
  font-family: 'Dasa Sans';
  line-height: 120%;
  letter-spacing: 0;

  ${media.lessThan('medium')`
     font-size: 1.6rem;
   `}

`

export const TextDescription = styled.p`
  color: #363636;
  font-size: 16px;
  font-weight: 400;
  font-family: 'Dasa Sans';
  line-height: 150%;
  letter-spacing: 0;
`
